<template>
  <span id="chatSettingMenu" draggable="false">
    <span class="dotIcon" @click="showMenu">
      <span></span>
    </span>
    <settingMenuItem id='chatSettingMenuItemContainer' :items='isAdmin?items.concat(adminItems):items' />
  </span>
</template>

<script>
import settingMenuItem from './chat-setting-menu-item-new'
import * as Cookies from 'js-cookie'

export default {
  data: function () {
    var itemsContainer = [
      { type: 'popup', name: 'popup', alt: '새창', method: this.popupchat, sp_icon_width: 0, sp_icon_height: -119 },
      { type: 'clear', name: 'clear', alt: '채팅지우기', method: this.clearMessages, sp_icon_width: -150, sp_icon_height: -117 },
      { type: 'font_up', name: 'font_up', alt: '글자크게', method: this.changeFontSizeUp, sp_icon_width: -81, sp_icon_height: -179 },
      { type: 'font_down', name: 'font_down', alt: '글자작게', method: this.changeFontSizeDown, sp_icon_width: -1, sp_icon_height: -180 },
      { type: 'refresh', name: 'refresh', alt: '새로고침', method: this.refreshScreen, sp_icon_width: 0, sp_icon_height: -49 },
      { type: 'cheer', name: 'cheer', alt: '응원채팅 설정', method: this.showCheerSetting, sp_icon_width: -79, sp_icon_height: 0 }
    ]
    var preventUserId = [
      'zkm4g0a339b075d96cdf36275aa84e2d0f988f4f', 'de9takm2d2d1dd4e9eb4e7e5ba3a0b75b6df8ce6'
    ]
    if (preventUserId.indexOf(window.userid) === -1) {
      // 20171120 긴급: 위의 아이디(zkm4g0a339b075d96cdf36275aa84e2d0f988f4f)만 체팅 설정이 되지 않도록 수정. (해제기간 모름, 문기님 요청, 종훈님 전달) by sukmin.lim
      // 20180313 긴급: 위의 아이디(de9takm2d2d1dd4e9eb4e7e5ba3a0b75b6df8ce6)만 체팅 설정이 되지 않도록 수정. (해제기간 모름, 문기님 요청, 종훈님 전달) by sukmin.lim (NAMED-7999)
      itemsContainer.push({ type: 'receive', name: 'receive', alt: '수신설정', method: this.showSetting, sp_icon_width: -80, sp_icon_height: -48 })
    }
    return {
      isAdmin: window.is_admin === undefined ? false : window.is_admin,
      items: itemsContainer,
      adminItems: [
        { type: 'ice', name: 'ice', alt: '채팅방 얼리기', method: this.freezeRoom, sp_icon_width: -150, sp_icon_height: -47 },
        { type: 'sun', name: 'sun', alt: '채팅방 녹이기', method: this.meltRoom, sp_icon_width: 0, sp_icon_height: 0 }
      ],
      remoteControllerItems: [
        { type: 'clear', name: 'clear', alt: '지우기', method: this.clearMessagesAdmin, sp_icon_width: 0, sp_icon_height: 0 },
        { type: 'ice', name: 'ice', alt: '얼리기', method: this.freezeRoom, sp_icon_width: 0, sp_icon_height: 0 },
        { type: 'sun', name: 'sun', alt: '녹이기', method: this.meltRoom, sp_icon_width: 0, sp_icon_height: 0 }
      ]
    }
  },
  methods: {
    showMenu: function (event) {
      // event.target.parentNode.classList.toggle('on')
      document.getElementById('chatSettingMenu').classList.toggle('on')
    },
    popupchat: function () {
      this.closeSettingMenu()
      let origin = '/nlivechat/chat.php'
      window.open(origin + '?winmode=popup&connect_mode=first&site_id=' + window.site_id + '#/' + window.site_id, 'chat_' + window.site_id, 'scrollbars=no,toolbar=no,resizable=yes,width=500,height=500,left=0,top=0')
    },
    changeFontSize: function (commend) {
      let chatBox = document.getElementById('chatMessageList')
      let currentFontValue = parseInt(chatBox.style.fontSize)
      let currentLineValue = parseInt(chatBox.style.lineHeight)

      if (currentFontValue < 18 && commend === 'up') {
        chatBox.style.fontSize = (currentFontValue + 1) + 'px'
        chatBox.style.lineHeight = (currentLineValue + 1) + 'px'
      }
      if (currentFontValue > 12 && commend === 'down') {
        chatBox.style.fontSize = (currentFontValue - 1) + 'px'
        chatBox.style.lineHeight = (currentLineValue - 1) + 'px'
      }
      Cookies.set('font_size', parseInt(chatBox.style.fontSize) + '', {path: '/', expires: 365})
      Cookies.set('line_size', parseInt(chatBox.style.lineHeight) + '', {path: '/', expires: 365})
    },
    closeSettingMenu: function () {
      this.$el.classList.remove('on')
    },
    changeFontSizeUp: function () {
      this.changeFontSize('up')
    },
    changeFontSizeDown: function () {
      this.changeFontSize('down')
    },
    clearMessages: function () {
      this.$store.dispatch('clearMessages')
      printSystemMessage('방청소완료!') // eslint-disable-line no-undef
      this.closeSettingMenu()
    },
    clearMessagesAdmin: function () {
      adminCmd('CLEAR', '', '') // eslint-disable-line no-undef
    },
    refreshScreen: function () {
      setTimeout(function () {
        window.location.reload()
      }, 1000)
    },
    showSetting: function () {
      this.closeSettingMenu()
      let menuWindow = window.document.getElementById('messageListSettingContainer')
      menuWindow.style.opacity = '1'
      menuWindow.style.visibility = 'visible'
    },
    showCheerSetting: function () {
      this.closeSettingMenu()
      let menuWindow = window.document.getElementById('messageListCheerSettingContainer')
      menuWindow.style.opacity = '1'
      menuWindow.style.visibility = 'visible'
    },
    freezeRoom: function () {
      adminCmd('FREEZE_ROOM', '', '') // eslint-disable-line no-undef
    },
    meltRoom: function () {
      adminCmd('MELT_ROOM', '', '') // eslint-disable-line no-undef
    },
    autoFreezeRoom: function () {
      toggleAutoFreezer() // eslint-disable-line
    }
  },
  components: {
    'settingMenuItem': settingMenuItem
  }
}
</script>

<style lang='scss'>
  #chatSettingMenu{
    display: inline-block;

    &.on{
      #chatSettingMenuItemContainer {display:block;}
    }
    .dotIcon{
      display: inline-block;
      cursor: pointer;
      padding: 0 12px;
      span{
        display:inline-block;
        height:20px;
        width:5px;
        background: var(--sport-chat-icon) -217px -178px /225px 199px;
        position: relative;
        vertical-align: middle;
      }
        &:hover{
          span{
            height:20px;
            width:5px;
            background: var(--sport-chat-icon) -215px -118px/ 225px 199px;
          }
        }
    }

    ul {
      display:none;
      z-index: 10000;
      position:absolute;
      width:200px;
      padding:10px 0;
      left: 0;
      top:58px;
      background:#fff;
      overflow:hidden;
      box-shadow: 1px 1px 3px #999;
    }
  }
</style>



// WEBPACK FOOTER //
// chat-setting-menu-new.vue?3c0cc212